import { TokenWithValue } from '@/domain/common/types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { Objective } from '@/features/actions/logic/types'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'

export interface CreateBorrowActionsParams {
  outputToken: TokenWithValue
  reserve: Reserve
}
export function createBorrowObjectives({ outputToken, reserve }: CreateBorrowActionsParams): Objective[] {
  if (outputToken.token.symbol === TokenSymbol('USDC') && reserve.token.symbol === TokenSymbol('USDS')) {
    return [
      {
        type: 'borrow',
        token: reserve.token,
        value: outputToken.value,
      },
      {
        type: 'swap',
        from: reserve.token,
        to: outputToken.token,
        amount: outputToken.value,
      },
    ]
  }

  return [
    {
      type: 'borrow',
      token: outputToken.token,
      value: outputToken.value,
    },
  ]
}
